export default function Contact() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            联系我们
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            有建议、合作意向或想投稿？欢迎通过以下方式找到我们
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
            <div className="bg-background-100 rounded-xl border border-background-200/60 p-5 md:p-6 text-center">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-primary-100 text-primary-600">
                <i className="ri-mail-line text-xl" />
              </div>
              <h3 className="mt-4 text-sm font-semibold text-foreground-900 font-heading">
                投稿与合作
              </h3>
              <p className="mt-2 text-xs text-foreground-500">
                欢迎漫画创作者投稿，也欢迎商业合作洽谈
              </p>
              <a
                href="#faq"
                className="mt-3 inline-block text-xs text-primary-600 font-medium cursor-pointer hover:text-primary-700"
              >
                了解更多 →
              </a>
            </div>

            <div className="bg-background-100 rounded-xl border border-background-200/60 p-5 md:p-6 text-center">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-accent-100 text-accent-600">
                <i className="ri-question-answer-line text-xl" />
              </div>
              <h3 className="mt-4 text-sm font-semibold text-foreground-900 font-heading">
                意见反馈
              </h3>
              <p className="mt-2 text-xs text-foreground-500">
                对香香漫画有任何建议或意见，我们认真倾听
              </p>
              <a
                href="#faq"
                className="mt-3 inline-block text-xs text-primary-600 font-medium cursor-pointer hover:text-primary-700"
              >
                查看常见问题 →
              </a>
            </div>

            <div className="bg-background-100 rounded-xl border border-background-200/60 p-5 md:p-6 text-center">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-700">
                <i className="ri-links-line text-xl" />
              </div>
              <h3 className="mt-4 text-sm font-semibold text-foreground-900 font-heading">
                官方入口
              </h3>
              <p className="mt-2 text-xs text-foreground-500">
                香香漫画官网入口安全直达，建议收藏网址
              </p>
              <a
                href="#hero"
                className="mt-3 inline-block text-xs text-primary-600 font-medium cursor-pointer hover:text-primary-700"
              >
                返回首页 →
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}